<h2 class="mat-h2">Sales momentum, 4 months absolute delta</h2>
<table>
  <ng-container *ngIf="salesMomentum$ | async as salesMomentum; else salesMomentumNoData">

    <ng-container *ngIf="showBricks">
      <tr>
        <th class="width20">Brick +</th>
        <th *ngIf="showTerritory">Territory</th>
        <th>Total # packs</th>
        <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
        <th [matTooltip]="momentumLongDesc">Δ PY</th>
        <th class="width20">Brick -</th>
        <th *ngIf="showTerritory">Territory</th>
        <th>Total # packs</th>
        <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
        <th [matTooltip]="momentumLongDesc">Δ PY</th>
      </tr>
      <tr *ngFor="let brick of salesMomentum.brickPlus; let i = index">
        <td class="green width20">{{ salesMomentum.brickPlus[i].brick }}</td>
        <td class="green" *ngIf="showTerritory">{{ salesMomentum.brickPlus[i].region }}</td>
        <td class="green">{{ salesMomentum.brickPlus[i].total }}</td>
        <td class="green">{{ salesMomentum.brickPlus[i].fourMonth }}</td>
        <td class="green">{{ salesMomentum.brickPlus[i].py }}</td>
        <td class="red width20">{{ salesMomentum.brickMinus[i].brick }}</td>
        <td class="red" *ngIf="showTerritory">{{ salesMomentum.brickMinus[i].region }}</td>
        <td class="red">{{ salesMomentum.brickMinus[i].total }}</td>
        <td class="red">{{ salesMomentum.brickMinus[i].fourMonth }}</td>
        <td class="red">{{ salesMomentum.brickMinus[i].py }}</td>
      </tr>
    </ng-container>

    <!-- <ng-container *ngIf="showAccounts">
      <tr>
        <th class="width20">Account +</th>
        <th *ngIf="showTerritory">Territory</th>
        <th>Total # packs</th>
        <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
        <th>Δ PY</th>
        <th class="width20">Account -</th>
        <th *ngIf="showTerritory">Territory</th>
        <th>Total # packs</th>
        <th [matTooltip]="momentumShortDesc">Δ 4 month</th>
        <th>Δ PY</th>
      </tr>
      <tr *ngFor="let account of salesMomentum.accountPlus; let i = index">
        <td class="green width20">{{ salesMomentum.accountPlus[i].account }}</td>
        <td class="green" *ngIf="showTerritory">{{ salesMomentum.accountPlus[i].region }}</td>
        <td class="green">{{ salesMomentum.accountPlus[i].total }}</td>
        <td class="green">{{ salesMomentum.accountPlus[i].fourMonth }}</td>
        <td class="green">{{ salesMomentum.accountPlus[i].py }}</td>
        <td class="red width20">{{ salesMomentum.accountMinus[i].account }}</td>
        <td class="red" *ngIf="showTerritory">{{ salesMomentum.accountMinus[i].region }}</td>
        <td class="red">{{ salesMomentum.accountMinus[i].total }}</td>
        <td class="red">{{ salesMomentum.accountMinus[i].fourMonth }}</td>
        <td class="red">{{ salesMomentum.accountMinus[i].py }}</td>
      </tr>
    </ng-container> -->

  </ng-container>

  <ng-template #salesMomentumNoData>
    <tr>
      <td [attr.colspan]="showTerritory ? 10 : 8" class="center">No data available</td>
    </tr>
  </ng-template>

  <ng-container *ngIf="!showBricks && !showAccounts">
    <tr>
      <td [attr.colspan]="showTerritory ? 10 : 8" class="center">No data available</td>
    </tr>
  </ng-container>
</table>
